module.exports = __webpack_public_path__ + "4dd35d768d05f7ed87489544b6788184.png";